import { Dialog, Flex } from "@radix-ui/themes";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { IoMdClose } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import RoomClient from "components/containers/utils/mediaSoup/RoomClient";
import { resetLiveStreamSettings } from "store/reducers/livestreamSettings";
import { useDispatch } from "react-redux";
import { AppDispatch } from "store";

interface LogoutProps {
  roomClient: RoomClient | null;
}

const LogoutControl = ({ roomClient }: LogoutProps) => {
  const isOn = false;
  const router = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const sessionJoinExit = async (type: any) => {
    dispatch(resetLiveStreamSettings())
    await roomClient.close();
    router("/dashboard");
  }

  return (
    <div className="relative group">
      <Dialog.Root>
        <Dialog.Trigger>
          {/* Matching icon button styling from LeftPanel */}
          <div
  className="mobile:w-14 mobile:h-14 w-16 h-16 rounded-full 
    bg-red-600 
    text-white
    shadow-[-6px_-6px_12px_rgba(255,255,255,0.25),6px_6px_12px_rgba(0,0,0,0.25)] 
    box-border flex items-center justify-center 
    hover:bg-red-600 transition"
>
  <RiLogoutCircleRLine size={28}/>
</div>

        </Dialog.Trigger>

        <Dialog.Content style={{ maxWidth: 450, padding: 0 }}>
          <div className="flex justify-end bg-app-yellow p-2">
            <Dialog.Title>
              <Dialog.Close>
                <p className="p-1">
                  <IoMdClose />
                </p>
              </Dialog.Close>
            </Dialog.Title>
          </div>
          <Dialog.Description size="2" mb="4">
            <div className="flex justify-center items-center font-medium text-zinc-700 p-2">
              Do you wish to exit the session?
            </div>
          </Dialog.Description>

          <Flex gap="3" mt="4" mb="4" justify="center">
            <Dialog.Close>
              <button
                onClick={sessionJoinExit}
                className="bg-gradient-to-br from-40% from-app-blue to-app-purple px-4 py-1 text-white rounded-2xl"
              >
                Yes
              </button>
            </Dialog.Close>
            <Dialog.Close>
              <button className="border border-app-blue px-4 py-1 rounded-2xl font-medium text-app-blue">
                No
              </button>
            </Dialog.Close>
          </Flex>
        </Dialog.Content>
      </Dialog.Root>

      <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 max-w-md bg-black text-white text-sm rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        Exit Session
      </div>
    </div>
  );
};

export default LogoutControl;
